import React, { useState, useEffect } from 'react'
import { isEmpty, isUndefined } from 'lodash'

import {
  Box,
  Typography,
  Button,
  RadioGroup,
  FormControlLabel,
  Radio,
  Divider,
} from '@material-ui/core'
import { CreateAgentDialog, ListAGents } from './components'

import clsx from 'clsx'
import { PlusCircle as PlusIcon } from 'react-feather'

import useSnackbar from 'hooks/useSnackbar'
import useDataProcess from 'hooks/useDataProcess'
import auth from 'hooks/useAuth'

import * as service from 'service'

import constants from 'constants/index'
import helpers from 'helpers'
import useStyles from './styles'

const DataTreatmentAgent = () => {
  const [openDialog, setOpenDialog] = useState(false)
  const [agents, setAgents] = useState([])
  const [dataTreatmentAgentsPresent, setDataTreatmentAgentsPresent] =
    useState(false)
  const [radioValue, setRadioValue] = useState('')
  const [agentEdition, setAgentEdition] = useState(null)

  const classes = useStyles()
  const snackbar = useSnackbar()

  const { company } = auth()

  const { data, nextStep, toNextStep, setToNextStep } = useDataProcess()

  const { dataProcess } = data

  const {
    CONTROLLER_TYPE,
    OPERATOR_TYPE,
    CONTROLLER_LABEL,
    OPERATOR_LABEL,
    CO_CONTROLLER_LABEL,
    CO_CONTROLLER_TYPE,
    SUBOPERATOR_LABEL,
    SUBOPERATOR_TYPE,
  } = constants.dataTreatmentAgents

  useEffect(() => {
    const allDataTreatementAgents = async () => {
      const response = await service.dponet.dataTreatmentAgents.index({
        dataProcessId: dataProcess?.id,
        perPage: 100_000,
      })
      setDataTreatmentAgentsPresent(
        !isEmpty(response?.data?.dataTreatmentAgents),
      )
      setRadioValue(
        helpers.dataTreatmentAgent.agentTypeOfCompanySelf(
          response?.data?.dataTreatmentAgents,
        ),
      )
      setAgents(response?.data?.dataTreatmentAgents)
    }

    allDataTreatementAgents()

    // eslint-disable-next-line
  }, [toNextStep])

  const isCompanyTemplate =
    company.kind === constants.userCompanies.KIND_TEMPLATE

  const handleCreateOrUpdate = () => {
    try {
      if (isEmpty(agents) && isCompanyTemplate) return
      if (dataTreatmentAgentsPresent) {
        service.dponet.dataTreatmentAgents.updateAll({
          dataProcessId: dataProcess?.id,
          agents: agents,
        })
      } else {
        service.dponet.dataTreatmentAgents.create({
          dataProcessId: dataProcess?.id,
          agents: agents,
        })
      }
    } catch (error) {
      snackbar.open({
        message:
          helpers.formatters.errorMessage(error?.response?.data?.error) ||
          'Ocorreu um erro, tente novamente mais tarde.',
        variant: 'error',
      })
    }
  }

  const verifyDataTreatmentAgent =
    helpers.dataTreatmentAgent.typeControllerIsPresent(agents)

  const handleChange = (event) => {
    if (!isUndefined(event.target.value)) {
      const agentsRebase = agents.filter(
        (agent) => agent.name !== company?.name,
      )
      setAgents([
        ...agentsRebase,
        {
          name: company?.name,
          agentType: event.target.value,
          companySelf: true,
          document: company?.document,
        },
      ])
    }
    setRadioValue(event.target.value)
  }

  const handleOpenCreateDialog = () => {
    setAgentEdition(null)
    setOpenDialog(true)
  }

  useEffect(() => {
    if (toNextStep) {
      if (verifyDataTreatmentAgent || isCompanyTemplate) {
        handleCreateOrUpdate()
        nextStep()
        setToNextStep(false)
      } else {
        snackbar.open({
          message: 'É necessário ter pelo menos um controlador dos dados',
          variant: 'error',
        })
      }
      setToNextStep(false)
    }
    // eslint-disable-next-line
  }, [nextStep])

  return (
    <Box
      id={constants.dataProcess.DATA_PROCESS_NEW_DRIVER_STEP_7}
      className={classes.root}
    >
      <Typography className={classes.subTitle}>
        O que você é nessa relação?
      </Typography>
      <Typography className={classes.span}>Selecione seu papel.</Typography>
      <RadioGroup onClick={handleChange} defaultValue={CONTROLLER_TYPE}>
        <FormControlLabel
          value={CONTROLLER_TYPE}
          className={classes.radioControl}
          control={<Radio className={classes.radioCheck} />}
          label={CONTROLLER_LABEL}
          checked={radioValue === CONTROLLER_TYPE}
        />
        <Divider />
        <FormControlLabel
          value={OPERATOR_TYPE}
          control={<Radio className={classes.radioCheck} />}
          label={OPERATOR_LABEL}
          className={classes.radioControl}
          checked={radioValue === OPERATOR_TYPE}
        />

        <FormControlLabel
          value={CO_CONTROLLER_TYPE}
          control={<Radio className={classes.radioCheck} />}
          label={CO_CONTROLLER_LABEL}
          checked={radioValue === CO_CONTROLLER_TYPE}
        />
        <FormControlLabel
          value={SUBOPERATOR_TYPE}
          control={<Radio />}
          label={SUBOPERATOR_LABEL}
          checked={radioValue === SUBOPERATOR_TYPE}
        />
      </RadioGroup>
      {!isEmpty(agents) && (
        <>
          <ListAGents
            agents={agents}
            setOpenDialog={setOpenDialog}
            setAgentEdition={setAgentEdition}
            setAgents={setAgents}
          />
          <Box className={classes.grayBox}>
            <Typography className={classes.label}>
              {radioValue === CONTROLLER_TYPE
                ? 'Existem mais organizações envolvidas?'
                : 'Adicione mais organizações.'}
            </Typography>
            <Button
              variant="outlined"
              className={clsx({
                [classes.primaryButton]: radioValue === CONTROLLER_TYPE,
              })}
              startIcon={<PlusIcon />}
              onClick={handleOpenCreateDialog}
            >
              Adicionar
            </Button>
          </Box>
        </>
      )}
      {openDialog && (
        <CreateAgentDialog
          open={openDialog}
          setOpen={setOpenDialog}
          setAgents={setAgents}
          agents={agents}
          agentEdition={agentEdition}
          setAgentEdition={setAgentEdition}
        />
      )}
    </Box>
  )
}

export default DataTreatmentAgent
